import { Component, Input } from "@angular/core";
import { Navigator } from 'src/app/components/menu/navigator';
import { PopoverController } from "@ionic/angular";
import { IBonusCheckPopover } from "src/app/interfaces/bonus-offer.interface";

@Component({
    selector: 'app-popover-bonus-check',
    templateUrl: './popover-bonus-check.component.html',
    styleUrls: ['./popover-bonus-check.component.scss'],
})
export class BonusCheckPopoverComponent {
    @Input() data: IBonusCheckPopover;

    constructor (
        private popOverCtrl: PopoverController,
        private navigator: Navigator,
    ) {}

    public closePopover(noAction = false) {
        try{
            this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
        }catch(e){
            this.popOverCtrl.dismiss();
        }
        if (this.data.buttonActionExtend && !noAction) {
            this.data.buttonActionExtend()
        }
    }
}